module.exports = __webpack_public_path__ + "static/media/98.079cab4d.gif";